








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { default as axios } from 'axios';
import { EggsCollect } from '../../interfaces/hens/hens.interface';
import { Utils } from '@/utils/utils';
import '@/utils/filter';

@Component({
  components: {},
})
export default class History extends Vue {
  public dialog: boolean = false;

  get history(): EggsCollect[] {
    return this.$store.state.eggsHistory;
  }

  constructor() {
    super();

    axios
      .get(`${process.env.VUE_APP_API_URL}/hens/all`)
      .then(response => {
        const result: EggsCollect[] = response.data as EggsCollect[];
        this.$store.dispatch('setEggsHistory', result);
      })
      .catch(err => {
        throw err;
      });
  }
}
